<template>
  <div :class="isPhoneUpload&&isPcUpload?'UploadMode isSplit':'UploadMode'">
    <div class="UploadBox">
      <PhoneUpload v-if="isPhoneUpload" :isUpload="isPhoneUpload" v-bind="$attrs"/>
      <!-- <PcUpload v-if="isPcUpload" :isUpload="isPcUpload" v-bind="$attrs"/> -->
    </div>

    <div
      :class="disabled ?'gray detail':'detail'"
      @click="onDetail"
    >
      查看发票详情
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
// import PcUpload from './components/PcUpload.vue';
import PhoneUpload from './components/PhoneUpload.vue';

export default {
  name: 'UploadMode',
  props: ['disabled'],
  components: {
    PhoneUpload,
    // PcUpload,
  },
  data() {
    return {
      isPhoneUpload: true,
      isPcUpload: false,
    };
  },
  mounted() {
    // this.getUploadType();
  },
  methods: {
    onDetail() {
      this.$emit('onDetail');
    },
    async getUploadType() {
      // 数据采集入口 0 不开通 1 手机上传 2电脑上传 3双端上传
      try {
        if (decodeURIComponent(this.$route.query.redirect || '') === '/supermarket/v2/bindEnterprise') {
          this.isPhoneUpload = true;
          this.isPcUpload = false;
          return;
        }
        const { data, returnMessage, returnCode } = await this.$api.PublicPage.getCollectInterface({
          orderId: this.$route.query.orderId,
        });
        if (returnCode === '200') {
          if (data.collectInterface === 1 || data.collectInterface === 3) {
            this.isPhoneUpload = true;
          }

          if (data.collectInterface === 2 || data.collectInterface === 3) {
            this.isPcUpload = true;
          }
        } else {
          returnMessage && Toast(returnMessage);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.UploadMode {
  margin: 0px 16px 0px 16px;
  border-radius: 4px;
  box-shadow: 0 2.5px 5px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  background: #fff;
  padding-bottom: 19px;
  .UploadBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .detail {
    background: #ff6538;
    border-radius: 4px;
    width: 164px;
    height: 44px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 30px;
  }
  .gray {
    color: #fff;
    background-color: #bcc8d1 !important;
    border: 1px solid #bcc8d1 !important;
  }
}
.UploadMode.isSplit::after {
  position: absolute;
  content: "";
  height: 120px;
  width: 0.5px;
  opacity: 0.35;
  background: #bcc2cc;
  top: 36px;
  left: 50%;
}
</style>
